import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

export type GetProviderTrackingLinkFactoryDependencies = {
  repository: ShipmentRepository
}

export function getProviderTrackingLinkFactory({
  repository,
}: GetProviderTrackingLinkFactoryDependencies) {
  return function getShipmentByUUID(uuid: string, config?: { signal?: AbortSignal }) {
    return repository.getProviderTrackingLink(uuid, config)
  }
}

export function getProviderTrackingLink(id: string, config?: { signal?: AbortSignal }) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const get = getProviderTrackingLinkFactory({ repository })

  return get(id, config)
}
